module.exports = __webpack_public_path__ + "static/img/8fb5c92a73e68b56b32f8b809dc2b54c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/workflow_disable_03.png
// module id = bV6o
// module chunks = 1